const REFERRAL_CLAIM_PENDING_KEY = "taroterra.referral-claim";

export function markReferralClaimPending(userId: string): void {
  try {
    sessionStorage.setItem(REFERRAL_CLAIM_PENDING_KEY, userId);
  } catch {
    // Приватный режим. Этот заход всё равно вызовет claim.
  }
}

export function referralClaimPendingUserId(): string | null {
  try {
    return sessionStorage.getItem(REFERRAL_CLAIM_PENDING_KEY);
  } catch {
    return null;
  }
}

export function clearReferralClaimPending(): void {
  try {
    sessionStorage.removeItem(REFERRAL_CLAIM_PENDING_KEY);
  } catch {
    // Флаг уже недоступен, повтор не на чем держать.
  }
}
